import React, { Component } from 'react';
import Thanks from './Thanks';
import FormError from './FormError';

const encode = (data) => {
	return Object.keys(data)
		.map(
			(key) =>
				encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
		)
		.join('&');
};

class ContactForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			name: '',
			email: '',
			message: '',
			submitted: false,
			errors: [],
			secret: '',
		};
	}

	handleSubmit = () => {
		fetch('/', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: encode({ 'form-name': 'contact', ...this.state }),
		})
			.then(() => {
				this.setState({
					...this.state,
					name: '',
					email: '',
					message: '',
					secret: '',
				});
			})
			.catch((error) => alert(error));
	};

	handleChange = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	};

	verifyFormData = (e) => {
		e.preventDefault();
		const { name, message, secret } = this.state;
		const errors = [];
		if (name.trim().length < 2) {
			const nameErr = {
				message: 'Name needs to be greater than 1 character',
			};
			errors.push(nameErr);
		}

		if (message.length < 20) {
			const messageErr = {
				message: 'Message needs to be greater than 20 characters',
			};
			errors.push(messageErr);
		}

		if (secret.length > 0) {
			const secretErr = {
				message: 'Sorry, something went wrong. Please try again later',
			};
			errors.push(secretErr);
		}

		this.setState({ errors, submitted: true });

		if (!errors.length) {
			this.handleSubmit();
		}
	};

	render() {
		const submitMessage = () => {
			return !this.state.errors.length ? (
				<Thanks />
			) : (
				<FormError messages={this.state.errors} />
			);
		};
		return (
			<form
				onSubmit={this.verifyFormData}
				name="contact"
				method="POST"
				className="form"
			>
				{this.state.submitted ? submitMessage() : null}
				<div className="form__group">
					<input
						type="text"
						name="name"
						className="form__input"
						placeholder="Name"
						required
						onChange={this.handleChange}
						value={this.state.name}
					/>
					<label htmlFor="name" className="form__label">
						Name
					</label>
				</div>
				<div className="form__group">
					<input
						type="email"
						name="email"
						className="form__input"
						placeholder="Email"
						required
						onChange={this.handleChange}
						value={this.state.email}
					/>
					<label htmlFor="email" className="form__label">
						Email
					</label>
				</div>
				<div className="form__group">
					<textarea
						type="text"
						className="form__input"
						name="message"
						cols="50"
						rows="10"
						placeholder="Message"
						required
						onChange={this.handleChange}
						value={this.state.message}
					/>
					<label htmlFor="message" className="form__label">
						Message
					</label>
				</div>
				<div className="form__group">
					<input
						type="text"
						name="secret"
						className="form__input-secret"
						placeholder="secret"
						onChange={this.handleChange}
						value={this.state.secret}
					/>
				</div>
				<div className="form__group">
					<button className="form__btn" type="submit" value="submit">
						Submit
					</button>
				</div>
			</form>
		);
	}
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/Form.js